<template>
  <div class="mt-2">
    <ConnectionInfo />
    <ProxyInfo />
    <Scrutineer />
    <VoteHistory />
    <QRCode />
  </div>
</template>
<script>
import ConnectionInfo from "@/components/ToolBar/ConnectionInfo";
import ProxyInfo from "@/components/ToolBar/ProxyInfo";
import Scrutineer from "@/components/ToolBar/Scrutineer";
import VoteHistory from "@/components/ToolBar/VoteHistory";
import QRCode from "@/components/ToolBar/QRCode";
import { mapState } from "vuex";
export default {
  components: {
    ConnectionInfo,
    ProxyInfo,
    Scrutineer,
    VoteHistory,
    QRCode
  },
  data() {
    return {
      title: process.env.VUE_APP_TITLE,
      showProxies: false
    };
  },
  computed: {
    proxyCount() {
      let count = 0;
      if (this.proxies) {
        count += this.proxies.length;
      }
      if (this.user.weightedProxy > 0) {
        count += this.user.weightedProxy;
      }
      return count;
    },
    ...mapState({
      user: (state) => state.user,
      proxies: (state) => state.proxies,
      event: (state) => state.event
    })
  }
};
</script>
<style scoped>
@media (max-width: 768px) {
  .welcome-text {
    display: none;
  }
  /*
  .app-logo {
    display: none;
  }
  */
}
</style>
